import classnames from 'classnames'

import { Props } from './types'

import ContentLoader from 'common/components/contentLoader'

import '@hotmart/cosmos/dist/tag'
import '@hotmart/cosmos/dist/tag/variations/red.css'
import '@hotmart/cosmos/dist/tag/variations/blue.css'
import '@hotmart/cosmos/dist/tag/variations/cyan.css'
import '@hotmart/cosmos/dist/tag/variations/green.css'
import '@hotmart/cosmos/dist/tag/variations/purple.css'
import '@hotmart/cosmos/dist/tag/variations/yellow.css'
import '@hotmart/cosmos/dist/tag/variations/small.css'
import '@hotmart/cosmos/dist/tag/variations/large.css'

const Tag = ({
  children,
  type,
  size,
  link,
  className = '',
  onClick,
  isLoading
}: Props) => {
  if (isLoading) {
    return <ContentLoader className={className} width={70} height={32} />
  }

  return (
    <hot-tag
      href={link}
      class={classnames(
        className,
        {
          [`hot-tag--${type}`]: Boolean(type),
          [`hot-tag--${size}`]: Boolean(size)
        }
      )}
      onClick={onClick}>
      {children}
    </hot-tag>
  )
}

export default Tag
